import React from "react";
const estiloSeparador = require('./separador.module.scss').default

export const Separador = () => <div className={estiloSeparador.separador}></div>

export const SeparadorSimpes = () => <div className={estiloSeparador.separadorSimpes}></div>